<template>
  <div class="box"><span >1</span>
    <div class="minbox">
    <li
          v-for="(item, index) in List"
          :key="index"
          @click="change(index)"
        >
          <img :src='item.picUrl' alt="">
        </li>
      </div>
  </div>
</template>

<script>
export default {
  name: 'pcIndex',
  data() {
    return {
      //List: ["首頁", "關於我們", "商務合作"],
      List: [
        {picUrl:'http://prodcdn.toponegames.cn/png/hkty/11.png'},
        {picUrl:'http://prodcdn.toponegames.cn/png/hkty/21.png'},
        {picUrl:'http://prodcdn.toponegames.cn/png/hkty/32.png'}
        ],
    };
  },
  methods:{
    change(index){
      if(index===0){
        this.$router.push('/')
      }else if (index===1){
        this.$router.push('/pcAbout')
      }else if (index===2){
        this.$router.push('/pcCooperation')
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.box{
  width: 100%;
  height: 925px;
  background-image: url("../../static/3.png");
  background-size: 100% 100%;
}
.minbox {
  display: flex;
  justify-content: space-around;
  margin-left: 51%;
  margin-top: 1%;
  margin-right: 0%;
}
span {
  opacity: calc(0);
}
li {
  cursor: pointer;
    list-style-type:none
}
</style>



// WEBPACK FOOTER //
// src/components/pcCooperation.vue